import * as React from "react";
import { ResultWrapper } from "../../../styles/ScanDetail";
import { color } from "../../../styles/color";

interface IStorageSearchValue {
  feetNo: string;
  matchNumber: string;
  searchName?: string;
}

interface IProps {
  dateInput: string | null;
  storageIsCheck: boolean | null;
  storageSearchValue: IStorageSearchValue;
}

const Result = ({ dateInput, storageIsCheck, storageSearchValue }: IProps) => {
  return (
    <ResultWrapper>
      <div className="resultInfo">
        <p>记录编号日期：{dateInput ? dateInput : ""}</p>
        <p>
          排除重复：
          {storageIsCheck === true ? "是" : storageIsCheck === null ? "" : "否"}
        </p>
        {storageSearchValue.matchNumber ? (
          <p>参赛编号：{storageSearchValue.matchNumber}</p>
        ) : null}
        {storageSearchValue.searchName ? (
          <p>参赛名称：{storageSearchValue.searchName}</p>
        ) : null}
        {storageSearchValue.feetNo ? (
          <p>足环号：{storageSearchValue.feetNo}</p>
        ) : null}
        <p style={{ color: `${color.default}`, fontSize: ".7rem" }}>
          ( 清零作业会影响统计数据 )
        </p>
      </div>
    </ResultWrapper>
  );
};

export default Result;
